import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import {
  AccountingTransactionsTable,
  type AccountingTransactionTableHeaderProps,
} from '../../../../../../../../../../features/accounting/transaction/accounting-transactions-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinanceAccounting,
      label: 'Transactions',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinanceAccounting>,
  head: () => getPageHead('Accounting Transactions'),
  component: AccountingTransactionList,
});

function TableHeader({ filter }: AccountingTransactionTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingFinanceAccounting}
    />
  );
}

function AccountingTransactionList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <AccountingTransactionsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
